var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "demo-page" },
    [
      _c("img", {
        staticClass: "logo-con",
        attrs: { src: require("../assets/logo-wight.png") }
      }),
      _vm._v(" "),
      _c("el-input", {
        attrs: {
          size: "medium",
          placeholder: _vm.formatMessage({
            id: "5g.message.h5.login.phone.name",
            defaultMessage: "手机号"
          }),
          type: "tel"
        },
        on: { blur: _vm.blurCheck },
        model: {
          value: _vm.phone,
          callback: function($$v) {
            _vm.phone = $$v
          },
          expression: "phone"
        }
      }),
      _vm._v(" "),
      !_vm.isValid && _vm.errorLabel
        ? _c("div", { staticClass: "errorText" }, [
            _vm._v(_vm._s(_vm.errorLabel))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { display: "flex", margin: "10px 0px" } },
        [
          _c("el-input", {
            staticStyle: { display: "inline-block", flex: "1" },
            attrs: { size: "medium", type: "text" },
            model: {
              value: _vm.verifyCodeVerify,
              callback: function($$v) {
                _vm.verifyCodeVerify = $$v
              },
              expression: "verifyCodeVerify"
            }
          }),
          _vm._v(" "),
          _vm.verifyUrl
            ? _c("img", {
                staticStyle: {
                  display: "inline-block",
                  height: "36px",
                  width: "111px"
                },
                attrs: { src: _vm.verifyUrl },
                on: { click: _vm.refreshVerifyCode }
              })
            : _c(
                "span",
                {
                  staticStyle: {
                    border: "1px solid #DCDFE6",
                    display: "inline-block",
                    height: "36px",
                    width: "111px",
                    "text-align": "center",
                    "line-height": "36px"
                  },
                  on: { click: _vm.refreshVerifyCode }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.formatMessage({
                        id: "5g.message.h5.login.input.phone",
                        defaultMessage: "请输入手机号"
                      })
                    )
                  )
                ]
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-input",
        {
          staticStyle: { margin: "10px 0px" },
          attrs: { size: "medium", type: "text" },
          model: {
            value: _vm.smsCode,
            callback: function($$v) {
              _vm.smsCode = $$v
            },
            expression: "smsCode"
          }
        },
        [
          _vm.getSmsInterval
            ? _c("template", { slot: "append" }, [
                _vm._v(_vm._s(_vm.timer) + "s")
              ])
            : _c("template", { slot: "append" }, [
                _c(
                  "div",
                  {
                    staticStyle: { color: "#2b9939" },
                    on: { click: _vm.sendSmsCode }
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.formatMessage({
                          id: "5g.message.h5.login.getCode",
                          defaultMessage: "获取验证码"
                        })
                      )
                    )
                  ]
                )
              ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "left", "margin-bottom": "10px" } },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.agree,
                callback: function($$v) {
                  _vm.agree = $$v
                },
                expression: "agree"
              }
            },
            [
              _c(
                "a",
                {
                  staticStyle: { color: "#2b9939" },
                  on: { click: _vm.showPrivacyPolicies }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.formatMessage({
                        id: "5g.message.h5.login.xieyi",
                        defaultMessage: "同意用户隐私政策"
                      })
                    )
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        { staticClass: "block-btn", on: { click: _vm.handleLogin } },
        [
          _vm._v(
            _vm._s(
              _vm.formatMessage({
                id: "5g.message.h5.login",
                defaultMessage: "登录"
              })
            )
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.formatMessage({
              id: "5g.message.h5.login.modal.title",
              defaultMessage: "用户注册及使用APP隐私协议"
            }),
            visible: _vm.showDialog,
            width: "90%",
            top: "16px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _c("div", { staticStyle: { "white-space": "pre-wrap" } }, [
            _vm._v(_vm._s(_vm.PolicyText))
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "text-align": "center" } }, [
            _vm._v("南京绛门信息科技股份有限公司")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "warning", plain: "" },
                  on: {
                    click: function($event) {
                      _vm.showDialog = false
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.formatMessage({
                        id: "5g.message.h5.login.xieyi",
                        defaultMessage: "同意用户隐私政策"
                      })
                    )
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-054ba53a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-054ba53a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/login/index.vue
// module id = null
// module chunks = 